module.exports = __webpack_public_path__ + "img/suggest-learn-blue.d5d1ab88.png";